import type { EmojiPackId } from './types';
import { emojiConfig, type FluentUiStyle } from './emojiSets';
import fluentui3d from './index_fluentui_3d.json';

const fluentuiByStyle: Record<FluentUiStyle, Record<string, string>> = {
  '3d': fluentui3d as Record<string, string>,
};

const packLists: Record<EmojiPackId, string[]> = {
  fluentui: Object.keys(fluentuiByStyle[emojiConfig.fluentuiStyle]),
};

export function getEmojiList(packId: EmojiPackId) {
  return packLists[packId] ?? [];
}
